/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EcommerceUserApiCreateReq
 */
export interface EcommerceUserApiCreateReq {
    /**
     * 平台字典ID。
     * @type {number}
     * @memberof EcommerceUserApiCreateReq
     */
    businessPlatformId: number;
    /**
     * 平台侧企业/店铺账号标识，如 Coupang Vendor ID。
     * @type {string}
     * @memberof EcommerceUserApiCreateReq
     */
    externalAccountId: string;
    /**
     * Access Key / AppKey 明文，仅用于服务端加密保存。
     * @type {string}
     * @memberof EcommerceUserApiCreateReq
     */
    credentialKey: string;
    /**
     * Secret Key / AppSecret 明文，仅用于服务端加密保存。
     * @type {string}
     * @memberof EcommerceUserApiCreateReq
     */
    credentialSecret: string;
    /**
     * 凭证有效期，可选；为空或勾选无限期时不判断过期。
     * @type {string}
     * @memberof EcommerceUserApiCreateReq
     */
    credentialExpireTime?: string;
    /**
     * 是否无限期；为true时忽略到期时间并落库为空。
     * @type {boolean}
     * @memberof EcommerceUserApiCreateReq
     */
    credentialExpireUnlimited?: boolean;
}

/**
 * Check if a given object implements the EcommerceUserApiCreateReq interface.
 */
export function instanceOfEcommerceUserApiCreateReq(value: object): value is EcommerceUserApiCreateReq {
    if (!('businessPlatformId' in value) || value['businessPlatformId'] === undefined) return false;
    if (!('externalAccountId' in value) || value['externalAccountId'] === undefined) return false;
    if (!('credentialKey' in value) || value['credentialKey'] === undefined) return false;
    if (!('credentialSecret' in value) || value['credentialSecret'] === undefined) return false;
    return true;
}

export function EcommerceUserApiCreateReqFromJSON(json: any): EcommerceUserApiCreateReq {
    return EcommerceUserApiCreateReqFromJSONTyped(json, false);
}

export function EcommerceUserApiCreateReqFromJSONTyped(json: any, ignoreDiscriminator: boolean): EcommerceUserApiCreateReq {
    if (json == null) {
        return json;
    }
    return {
        
        'businessPlatformId': json['businessPlatformId'],
        'externalAccountId': json['externalAccountId'],
        'credentialKey': json['credentialKey'],
        'credentialSecret': json['credentialSecret'],
        'credentialExpireTime': json['credentialExpireTime'] == null ? undefined : json['credentialExpireTime'],
        'credentialExpireUnlimited': json['credentialExpireUnlimited'] == null ? undefined : json['credentialExpireUnlimited'],
    };
}

export function EcommerceUserApiCreateReqToJSON(json: any): EcommerceUserApiCreateReq {
    return EcommerceUserApiCreateReqToJSONTyped(json, false);
}

export function EcommerceUserApiCreateReqToJSONTyped(value?: EcommerceUserApiCreateReq | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'businessPlatformId': value['businessPlatformId'],
        'externalAccountId': value['externalAccountId'],
        'credentialKey': value['credentialKey'],
        'credentialSecret': value['credentialSecret'],
        'credentialExpireTime': value['credentialExpireTime'],
        'credentialExpireUnlimited': value['credentialExpireUnlimited'],
    };
}

